import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { Button } from './ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from './ui/dialog';
import { Textarea } from './ui/textarea';
import { clinicLeadAPI as leadsApi } from '../utils/api';

// LIFECYCLE-V3.2 — explicit provider-confirmed external sale. Backend is the authority (source, RBAC, state, G1).
export const MarkAsWonDialog = ({ lead, open, onClose, onDone }) => {
  const { t } = useTranslation();
  const [reason, setReason] = useState('');
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    if (!reason.trim()) { toast.error(t('provider.leads.markWon.reasonRequired')); return; }
    setBusy(true);
    try {
      await leadsApi.markWon(lead.id, reason.trim());
      toast.success(t('provider.leads.markWon.success'));
      onDone?.();
      onClose();
    } catch (e) {
      const code = e?.response?.data?.code;
      toast.error(code ? t(`provider.leads.markWon.errors.${code}`, { defaultValue: e.response.data.message || code }) : t('common.error'));
    } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent data-testid="mark-won-dialog">
        <DialogHeader><DialogTitle>{t('provider.leads.markWon.title')}</DialogTitle></DialogHeader>
        <p className="text-sm text-muted-foreground">{t('provider.leads.markWon.description')}</p>
        <Textarea data-testid="mark-won-reason" value={reason} onChange={(e) => setReason(e.target.value)} placeholder={t('provider.leads.markWon.reasonPlaceholder')} />
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="mark-won-cancel">{t('common.cancel')}</Button>
          <Button onClick={submit} disabled={busy || !reason.trim()} data-testid="mark-won-confirm">{t('provider.leads.markWon.confirm')}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
export default MarkAsWonDialog;
